export default __webpack_public_path__ + "static/bg_baigun-d8344b93047d64b0ee7e7345e6205313.jpg";